import { QueryClient } from '@tanstack/react-query'
import { makeFeatureFlagKey } from '@/global/utils'
import { getFeatureFlag } from '@/global/plugins/firebase'

const prefetchFeatureFlag = async (
  queryClient: QueryClient,
  namespace: string,
  key: string
) => {
  await queryClient.prefetchQuery({
    queryKey: makeFeatureFlagKey({ namespace, key }),
    queryFn: () => getFeatureFlag({ namespace, key })
  })
}

export { prefetchFeatureFlag }
